/* eslint-disable import/no-cycle */
import Container from './Container'

export default Container
